import { atom } from 'jotai';
import { atomFamily } from 'jotai/utils';

export interface VerificationState {
  status: boolean | null;
  commentsCount: number;
}

/**
 * Shared atom family for persisting verification state across component remounts.
 * Key format: "{nriCalculationId}-{type}" where type is 'nri' or 'wi'
 *
 * Used by:
 * - nri-table components for individual verification controls
 * - slot-summary-table for aggregated verification counts
 */
export const verificationStateAtomFamily = atomFamily((_key: string) =>
  atom<VerificationState | null>(null)
);
